import React from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import { callApi } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'

const AdminTemplateGroupCreate = ({ dispatch, navigate, configs, adminQuestions }) => {
    const submitFX = async (formData, formId) => {
        formData.isActive = true
        dispatch(callApi(apiResourceEndpoint('admin/input-groups', 'CREATE'), formData, formId))
    }

    const successFX = (groupId) => {
        navigate(buildRoutePath(routes.adminTemplateGroupView.path, { groupId }))
    }

    const cancelAction = () => {
        navigate(buildRoutePath(routes.adminTemplateGroupIndex.path))
    }

    return (
        <div className="admin-dashboard">
            <div className="header">
                <div className="container">
                    <div className="header-details">
                        <h1>Add a New Template Group</h1>
                    </div>
                </div>
            </div>
            <div className="content-wrapper">
                <div className="container">
                    <div className="content-box">
                        <SHSForm extraClass="flex-form" submitFX={submitFX} successFX={successFX} showCancel={true} cancelAction={cancelAction}>
                            <InputElement
                                type="text"
                                id="name"
                                label="Section Name"
                                placeholder="Basic Truck Information"
                                extraClass="flex-50"
                                required />
                        </SHSForm>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouterProps(connect()(AdminTemplateGroupCreate))
